import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGroup } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faEllipsis } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@components/basics/Dropdowns/GlobalDropdown';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { NAV_LINKS } from '@utils/constants';

export const ViewCommunityDropdown = ({
  align = 'start',
}: {
  align?: 'center' | 'start' | 'end';
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild className="outline-none">
        <IconButton icon={<FontAwesomeIcon icon={faEllipsis} size="lg" />} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} avoidCollisions>
        <AccessibleLink absoluteUri={NAV_LINKS.Community} type="external">
          <DropdownMenuItem>
            <div className="flex gap-2">
              <FontAwesomeIcon icon={faUserGroup} />
              <p>View My Community</p>
            </div>
          </DropdownMenuItem>
        </AccessibleLink>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
